<div *ngIf="orderTemplates?.length > 0; else noOrderTemplate" class="filter-list">
  <div *ngIf="orderTemplates?.length > 1; else oneTemplate">
    <p class="filter-item">
      {{ 'dias.filter.order_template.count.text' | translate : { '0': orderTemplates?.length } }}
    </p>
  </div>
  <ng-template #oneTemplate>
    <p class="filter-item">{{ 'dias.filter.order_template.one.text' | translate : { '0': orderTemplates?.length } }}</p>
  </ng-template>
  <div *ngFor="let orderTemplate of orderTemplates" class="filter-item custom-orderlist-link">
    <a [routerLink]="'/account/order-templates/' + orderTemplate.id" data-testing-id="order-template-list-title">
      {{ orderTemplate.title }}
    </a>

    <div>
      <a *ngIf="orderTemplate.items?.length" class="btn-tool d-inline-flex align-top">
        <ish-product-add-to-basket
          ishProductContext
          [parts]="getParts(orderTemplate)"
          displayType="icon"
          cssClass="text-primary p-0"
        ></ish-product-add-to-basket>
      </a>

      <a
        *ngIf="orderTemplate.editable"
        class="btn-tool"
        title="{{ 'account.order_template.list.link.remove' | translate }}"
        (click)="openDeleteConfirmationDialog(orderTemplate, deleteDialog)"
        data-testing-id="delete-order-template"
      >
        <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
      </a>
    </div>
  </div>
</div>
<ng-template #noOrderTemplate>
  <p class="filter-item" data-testing-id="emptyList">
    {{ 'account.order_template.list.no_templates.text' | translate }}
  </p>
</ng-template>

<ish-modal-dialog
  #deleteDialog
  [options]="{
    confirmText: 'account.order_template.delete.button.text' | translate,
    rejectText: 'account.cancel.button.label' | translate,
    titleText: 'undefined'
  }"
  (confirmed)="delete($event)"
>
  {{ 'account.order_template.delete.do_you_really.text' | translate }}
</ish-modal-dialog>
